import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  tableHead,
  subHead,
  sidingOrder,
  commodityOrder,
  columnOrderForDownload,
} from "./CASHelper";

import {
  diffInDays,
  formatDateToDis,
  getCurrentDate,
  getDateDifference,
} from "../../Utilitie";
import DownloadExcel from "../../Extra/DownloadExcel";
import DownloadExcelFromData from "../../Extra/DownloadExcelFromData";
import ActualLoadingSummary from "./ActualLoadingSummary";
const tableHeading = {
  CEMT: "F/C LOADING JBP DIVN",
  OTHER: "RAKE LOADING ( OTHER THAN CEMENT )",
  ADV: "ADVANCE LOADING ",
};
const CASLoadingReport = ({ activePage, data, date }) => {
  const getColorCode = (obj) => {
    const sortedExp = [...(obj.exp_ready || [])].sort(
      (a, b) => new Date(b.exp_ready_date) - new Date(a.exp_ready_date),
    );

    const latestExpDate = sortedExp[0]?.exp_ready_date?.slice(0, 10);
    const oldestExpDate = sortedExp[
      sortedExp.length - 1
    ]?.exp_ready_date?.slice(0, 10);

    const readyDate = obj?.ready_date?.slice(0, 10) || null;
    const currentDate = getCurrentDate();

    if (!latestExpDate) return "";

    if (!readyDate) {
      if (date.from > latestExpDate) {
        return "bg-custom-danger";
      }
      if (oldestExpDate <= date.from && date.from <= latestExpDate) {
        return "bg-custom-danger";
      }
    } else {
      if (latestExpDate > readyDate && readyDate === date.from) {
        return "bg-custom-success";
      }

      if (oldestExpDate && readyDate > oldestExpDate) {
        return "bg-custom-danger";
      }
    }

    return "";
  };

  const colorPriority = {
    "bg-custom-danger": 0,
    "bg-custom-success": 1,
    "": 2,
  };

  const sortedData = [...data].sort((a, b) => {
    const aPriority = colorPriority[getColorCode(a)] ?? 99;
    const bPriority = colorPriority[getColorCode(b)] ?? 99;

    if (aPriority !== bPriority) {
      return aPriority - bPriority;
    }

    const getIndex = (value, order) => {
      const index = order.indexOf(value);
      return index === -1 ? Number.MAX_SAFE_INTEGER : index;
    };

    if (activePage === "CEMT") {
      return getIndex(a.siding, sidingOrder) - getIndex(b.siding, sidingOrder);
    }

    return (
      getIndex(a.commodity, commodityOrder) -
      getIndex(b.commodity, commodityOrder)
    );
  });

  const formattedData = data.map((item) => {
    const latestExp =
      Array.isArray(item.exp_ready) && item.exp_ready.length > 0
        ? item.exp_ready.reduce((latest, current) =>
            new Date(current.exp_ready_date) > new Date(latest.exp_ready_date)
              ? current
              : latest,
          )
        : {
            exp_ready_date: null,
            exp_ready_time: null,
            exp_ready_remark: null,
          };

    return {
      ...item,
      arr_date: item.arr_date?.slice(0, 10),
      exp_ready_date: item.exp_ready_date?.slice(0, 10),
      order_date: item.order_date?.slice(0, 10),
      placed_date: item.placed_date?.slice(0, 10),
      ready_date: item.ready_date?.slice(0, 10),
      report_date: item.report_date?.slice(0, 10),
      siding_date: item.siding_date?.slice(0, 10),
      // Flatten into the main object
      exp_ready_date: latestExp?.exp_ready_date?.slice(0, 10),
      exp_ready_time: latestExp.exp_ready_time,
      exp_ready_remark: latestExp.exp_ready_remark,

      // Keep exp_ready as an array with only one object
    };
  });
  const tableRef = useRef();
  // Number of rows per page
  const [rowsPerPage, setRowsPerPage] = useState(sortedData.length);
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(sortedData.length / rowsPerPage);
  const paginatedsortedData = useMemo(() => {
    const start = (currentPage - 1) * rowsPerPage;
    return sortedData.slice(start, start + rowsPerPage);
  }, [sortedData, currentPage]);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  return (
    <div className="newUiBody " ref={tableRef}>
      <div className="m-0 p-0  ">
        <h5 className="bg-dark text-white ">{tableHeading[activePage]}</h5>
      </div>
      <div className="table-responsive ">
        <div style={{ maxHeight: "600px", overflow: "auto" }}>
          <table className="table table-hover table-striped table-bordered m-0">
            <thead className="sticky-top" style={{ zIndex: 4 }}>
              <tr
                className="table-dark text-uppercase"
                style={{ fontSize: "11px", letterSpacing: "0.5px" }}
              >
                {tableHead.map((h, i) => (
                  <th
                    key={i}
                    rowSpan={h.rowSpan}
                    colSpan={h.colSpan}
                    style={{
                      textAlign: "center",
                      verticalAlign: "middle",
                      position: "sticky",
                      top: 0,
                      zIndex: 30,
                      fontSize: "12px",
                      background: "#212529",
                    }}
                  >
                    {h.head}
                  </th>
                ))}
              </tr>

              <tr className="table-dark  px-3 fw-bold text-dark border-bottom border-light">
                {subHead.map((text, i) => (
                  <th
                    key={i}
                    style={{
                      textAlign: "center",
                      position: "sticky",
                      top: "38px",
                      zIndex: 30,
                      fontSize: "12px",
                      background: "#212529",
                    }}
                  >
                    {text}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {paginatedsortedData.map((obj, i) => {
                const colorCode = getColorCode(obj);
                // let colorCode = "";
                // const sortedExp = obj.exp_ready.sort((a, b) => {
                //   const aDate = new Date(a.exp_ready_date);
                //   const bDate = new Date(b.exp_ready_date);
                //   return bDate - aDate; // latest exp_ready_date first
                // });
                // const latestExpDate = sortedExp?.[0]?.exp_ready_date?.slice(
                //   0,
                //   10,
                // );
                // const oldestExpDate = sortedExp?.[
                //   sortedData.length
                // ]?.exp_ready_date?.slice(0, 10);
                // const ReadyDate = obj?.ready_date?.slice(0, 10) || null;
                // const currentDate = getCurrentDate();
                // if (!ReadyDate) {
                //   if (currentDate > latestExpDate) {
                //     colorCode = "bg-custom-danger";
                //   }
                // } else {
                //   // console.log("in else part", date.from, oldestExpDate);
                //   if (latestExpDate > ReadyDate && ReadyDate === date.from) {
                //     colorCode = "bg-custom-success";
                //   } else if (ReadyDate > oldestExpDate) {
                //     colorCode = "bg-custom-danger";
                //   }
                // }

                return (
                  <tr
                    className="m-1 p-1"
                    key={i}
                    rowSpan={obj.exp_ready.length}
                  >
                    <td
                      className={`px-3 fw-bold text-dark ${colorCode}`}
                      style={{
                        position: "sticky",
                        left: 0,
                        zIndex: 2,
                        backgroundColor: "rgba(255, 255, 255, 0.6)",
                        backdropFilter: "blur(12px)",
                        WebkitBackdropFilter: "blur(12px)",
                        borderRight: "1px solid rgba(255,255,255,0.4)",
                        boxShadow: "2px 0 5px rgba(0,0,0,0.05)",
                      }}
                    >
                      {(currentPage - 1) * rowsPerPage + i + 1}
                    </td>
                    <td
                      className={`px-3 fw-bold text-dark ${colorCode}`}
                      style={{
                        position: "sticky",
                        left: 0,
                        zIndex: 2,
                        backgroundColor: "rgba(255, 255, 255, 0.6)",
                        backdropFilter: "blur(12px)",
                        WebkitBackdropFilter: "blur(12px)",
                        borderRight: "1px solid rgba(255,255,255,0.4)",
                        boxShadow: "2px 0 5px rgba(0,0,0,0.05)",
                      }}
                    >
                      {obj.siding !== "-" ? (
                        obj.siding.split(" + ").map((point, idx, arr) => (
                          <span
                            key={idx}
                            className="d-inline-flex align-items-center"
                          >
                            <span
                              className="px-2 py-1 rounded fw-bold shadow-sm"
                              style={{
                                backgroundColor: "rgba(255, 237, 213, 0.8)",
                                color: "#c2410c",
                                border: "1px solid rgba(255, 237, 213, 0.5)",
                                fontSize: "11px",
                                letterSpacing: "0.5px",
                              }}
                            >
                              {point}
                            </span>
                            {idx < arr.length - 1 && (
                              <span className="mx-1 text-dark fw-bold">+</span>
                            )}
                          </span>
                        ))
                      ) : (
                        <span className="text-dark opacity-50">-</span>
                      )}
                    </td>
                    <td className={`px-3 fw-bold text-dark ${colorCode}`}>
                      {" "}
                      {obj.destination !== "-" ? (
                        obj.destination.split(" + ").map((point, idx, arr) => (
                          <span
                            key={idx}
                            className="d-inline-flex align-items-center"
                          >
                            <span
                              className="px-2 py-1 rounded fw-bold shadow-sm"
                              style={{
                                backgroundColor: "rgba(224, 242, 254, 0.8)",
                                color: "#0369a1",
                                border: "1px solid rgba(224, 242, 254, 0.5)",
                                fontSize: "11px",
                                letterSpacing: "0.5px",
                              }}
                            >
                              {point}
                            </span>
                            {idx < arr.length - 1 && (
                              <span className="mx-1 text-dark fw-bold">+</span>
                            )}
                          </span>
                        ))
                      ) : (
                        <span className="text-dark opacity-50">-</span>
                      )}
                    </td>
                    <td
                      className={`px-3 fw-bold text-dark ${colorCode} text-wrap`}
                      style={{ fontSize: "13px", maxWidth: "200px" }}
                    >
                      {obj.embedded_supply || "-"}
                    </td>
                    <td
                      className={`px-3 fw-bold text-dark ${colorCode}`}
                      style={{
                        fontSize: "13px",
                        width: "200px",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {obj.last_ire || "-"}
                    </td>
                    <td
                      className={`px-3 fw-bold text-dark ${colorCode}`}
                      style={{ fontSize: "13px" }}
                    >
                      {obj.commodity || "-"}
                    </td>
                    <td
                      className={`px-3 fw-bold text-dark ${colorCode}`}
                      style={{ fontSize: "13px" }}
                    >
                      {obj.wagons || "-"}
                    </td>
                    <td
                      className={`px-3 fw-bold text-dark ${colorCode}`}
                      style={{ fontSize: "13px" }}
                    >
                      {obj.loading_wagons || "-"}
                    </td>{" "}
                    <td
                      className={`px-3 fw-bold text-dark ${colorCode}`}
                      style={{ fontSize: "13px" }}
                    >
                      {obj.wagon_type || "-"}
                    </td>
                    <td
                      className={`px-3 fw-bold text-dark ${colorCode}`}
                      style={{ fontSize: "13px" }}
                    >
                      {obj.fcn_no || "-"}
                    </td>
                    <td className={`px-3 fw-bold text-dark ${colorCode}`}>
                      {" "}
                      <div className="d-flex flex-column justify-content-center">
                        <span
                          className="text-dark fw-bold"
                          style={{ fontSize: "13px", opacity: 0.8 }}
                        >
                          {formatDateToDis(obj?.order_date?.slice(0, 10))}
                        </span>
                        {obj.order_time && (
                          <span
                            className="text-muted fw-semibold"
                            style={{
                              fontSize: "11px",
                              letterSpacing: "0.5px",
                            }}
                          >
                            {obj.order_time || "-"}
                          </span>
                        )}
                      </div>
                    </td>
                    <td className={`px-3 fw-bold text-dark ${colorCode}`}>
                      {" "}
                      <div className="d-flex flex-column justify-content-center">
                        <span
                          className="text-dark fw-bold"
                          style={{ fontSize: "13px", opacity: 0.8 }}
                        >
                          {formatDateToDis(obj?.arr_date?.slice(0, 10))}
                        </span>
                        {obj.order_time && (
                          <span
                            className="text-muted fw-semibold"
                            style={{
                              fontSize: "11px",
                              letterSpacing: "0.5px",
                            }}
                          >
                            {obj.arr_time || "-"}
                          </span>
                        )}
                      </div>
                    </td>
                    <td className={`px-3 fw-bold text-dark ${colorCode}`}>
                      {" "}
                      <div className="d-flex flex-column justify-content-center">
                        <span
                          className="text-dark fw-bold"
                          style={{ fontSize: "13px", opacity: 0.8 }}
                        >
                          {formatDateToDis(obj?.placed_date?.slice(0, 10))}
                        </span>
                        {obj.placed_time && (
                          <span
                            className="text-muted fw-semibold"
                            style={{
                              fontSize: "11px",
                              letterSpacing: "0.5px",
                            }}
                          >
                            {obj.placed_time || "-"}
                          </span>
                        )}
                      </div>
                    </td>
                    <td
                      className={`px-3 fw-bold text-dark ${colorCode}`}
                      style={{ fontSize: "13px" }}
                    >
                      {obj.exp_ready.length > 0
                        ? obj.exp_ready
                            .sort((a, b) => {
                              const aDate = new Date(a.exp_ready_date);
                              const bDate = new Date(b.exp_ready_date);

                              return bDate - aDate; // latest exp_ready_date first
                            })
                            .map((exp, j) => {
                              return (
                                <tr key={j}>
                                  <div className="d-flex  justify-content-between align-item-center">
                                    <div className="d-flex flex-column justify-content-center">
                                      <span
                                        className="text-dark fw-bold"
                                        style={{
                                          fontSize: "13px",
                                          opacity: 0.8,
                                        }}
                                      >
                                        {formatDateToDis(
                                          exp?.exp_ready_date?.slice(0, 10),
                                        )}
                                      </span>
                                      {exp.exp_ready_time && (
                                        <span
                                          className="text-muted fw-semibold"
                                          style={{
                                            fontSize: "11px",
                                            letterSpacing: "0.5px",
                                          }}
                                        >
                                          {exp.exp_ready_time || "-"}
                                        </span>
                                      )}
                                    </div>
                                    <div>-</div>
                                    <span className="text-primary fw-bold ">
                                      {exp.exp_ready_remark}
                                    </span>
                                  </div>
                                </tr>
                              );
                            })
                        : "-"}
                    </td>
                    <td
                      className={`px-3 fw-bold text-dark ${colorCode}`}
                      style={{ fontSize: "13px" }}
                    >
                      <div className="d-flex flex-column justify-content-center">
                        <span
                          className="text-dark fw-bold"
                          style={{ fontSize: "13px", opacity: 0.8 }}
                        >
                          {formatDateToDis(obj?.ready_date?.slice(0, 10))}
                        </span>
                        {obj.ready_time && (
                          <span
                            className="text-muted fw-semibold"
                            style={{
                              fontSize: "11px",
                              letterSpacing: "0.5px",
                            }}
                          >
                            {obj.ready_time || "-"}
                          </span>
                        )}
                      </div>
                    </td>
                    <td
                      className={`px-3 fw-bold text-dark ${colorCode}`}
                      style={{ fontSize: "13px" }}
                    >
                      {obj.bpc || "-"}
                    </td>
                    <td
                      className={`px-3 fw-bold text-dark ${colorCode}`}
                      style={{ fontSize: "13px" }}
                    >
                      {obj.valid || "-"}
                    </td>
                    <td
                      className={`px-3 fw-bold text-dark ${colorCode}`}
                      style={{ fontSize: "13px" }}
                    >
                      <div className="d-flex flex-column justify-content-center">
                        <span
                          className="text-dark fw-bold"
                          style={{ fontSize: "13px", opacity: 0.8 }}
                        >
                          {formatDateToDis(obj?.siding_date?.slice(0, 10))}
                        </span>
                        {obj.siding_time && (
                          <span
                            className="text-muted fw-semibold"
                            style={{
                              fontSize: "11px",
                              letterSpacing: "0.5px",
                            }}
                          >
                            {obj.siding_time || "-"}
                          </span>
                        )}
                      </div>
                    </td>
                    <td
                      className={`px-3 fw-bold text-dark ${colorCode}`}
                      style={{ fontSize: "13px" }}
                    >
                      {obj.rl_dp || "-"}
                    </td>
                    <td
                      className={`px-3 fw-bold text-dark ${colorCode} text-wrap `}
                      style={{ fontSize: "13px", maxWidth: "200px" }}
                    >
                      {obj.remarks || "-"}
                    </td>
                    {/* Your remaining columns */}
                  </tr>
                );
              })}

              {paginatedsortedData.length === 0 && (
                <tr>
                  <td
                    colSpan={tableHead.reduce(
                      (sum, h) => sum + (h.colSpan || 1),
                      0,
                    )}
                    className="text-center py-3"
                  >
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* Footer */}
        <div className="d-flex justify-content-between align-items-center border-top p-2 ">
          {/* <div>
            Showing{" "}
            <strong>
              {sortedData.length === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1}
            </strong>{" "}
            -
            <strong> {Math.min(currentPage * rowsPerPage, sortedData.length)}</strong>{" "}
            of <strong>{sortedData.length}</strong> records
          </div>

          <div className="d-flex align-items-center gap-2">
            <button
              className="btn btn-sm btn-outline-secondary"
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
            >
              Previous
            </button>

            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i}
                className={`btn btn-sm ${
                  currentPage === i + 1 ? "btn-primary" : "btn-outline-primary"
                }`}
                onClick={() => handlePageChange(i + 1)}
              >
                {i + 1}
              </button>
            ))}

            <button
              className="btn btn-sm btn-outline-secondary"
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => handlePageChange(currentPage + 1)}
            >
              Next
            </button>
            {/* <button
              className="btn btn-sm btn-outline-secondary"
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => {
                setRowsPerPage(sortedData.length);
                setCurrentPage(1);
              }}
            >
              Show Full Table
            </button> */}
          {/* </div> */}

          {/* <DownloadExcel
            tableRef={tableRef}
            fileName={`Loading sortedData From- ${date.from} to -${date.to}`}
          /> */}
          <div className=" ">
            <div className="d-flex  align-items-center">
              <div
                className=" bg-custom-success me-1"
                style={{ width: "20px", height: "20px", borderRadius: "50%" }}
              ></div>
              Ready date is newer then the expected ready date{" "}
            </div>
            <div className="d-flex  align-items-center">
              <div
                className=" bg-custom-danger me-1"
                style={{ width: "20px", height: "20px", borderRadius: "50%" }}
              ></div>
              Ready date or current date is newer then the expected ready
              date{" "}
            </div>
          </div>
          <DownloadExcelFromData
            data={formattedData}
            columnOrder={columnOrderForDownload}
            fileName={`Loading sortedData From- ${date.from} to -${date.to}`}
          />
        </div>
      </div>
    </div>
  );
};

export default CASLoadingReport;
